import { render, staticRenderFns } from "./combineMovementTable.vue?vue&type=template&id=33f16280&"
import script from "./combineMovementTable.vue?vue&type=script&lang=js&"
export * from "./combineMovementTable.vue?vue&type=script&lang=js&"
import style0 from "./combineMovementTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports